import { Component, Input, OnInit } from '@angular/core';
import { ISurveyAnswer } from '@maplix/utils';

@Component({
  selector: 'maplix-popup-fieldtype-table',
  templateUrl: './popup-fieldtype-table.component.html',
  styleUrls: ['./popup-fieldtype-table.component.scss']
})
export class PopupFieldtypeTableComponent implements OnInit {
  @Input()
  public answer: ISurveyAnswer;

  constructor() { }

  ngOnInit(): void {
  }

}
